<template>
  <div
    class="solfigrf-sizes solfigrssz gw_overlay gw_overlay_m"
    :class="`solfigrssz_${player}`"
  >
    <div
      v-if="overlayCopyFlop || overlayCopyFirstPlayer"
      class="gw_overlay_content cursor-default gw_loading_text"
      style="--opacity: 1; z-index: 7; --clr-back: rgba(38, 38, 38, 0.6)"
    >
      <div class="clr-grey gw_box text-medium">
        <div
          v-if="overlayCopyFirstPlayer"
          class="f-column"
        >
          {{
            $t('solfigr.sizes.settings_inherited_from_OOP', {
              display_position: firstPlayer.display_position,
            })
          }}
          <div
            class="gw_btn mt-2 px-4 mx-auto"
            style="--clr-hover-white: rgba(245, 83, 83)"
            @click="$emit('click:disableclonefirstplayer', player)"
          >
            <div class="mdi mdi-stop-circle-outline mr-1"></div>
            {{ $t('btn.disable') }}
          </div>
        </div>
        <div
          v-else-if="overlayCopyFlop"
          class="f-column"
        >
          {{ $t('solfigr.sizes.settings_inherited_from_flop') }}
          <div
            class="gw_btn mt-2 px-4 mx-auto"
            style="--clr-hover-white: rgba(245, 83, 83)"
            @click="$emit('click:disablecopyflop')"
          >
            <div class="mdi mdi-stop-circle-outline mr-1"></div>
            {{ $t('btn.disable') }}
          </div>
        </div>
      </div>
    </div>

    <div class="solfigrssz_bettypes">
      <div class="f-row">
        <GwTitleTooltip
          class="solfigrssz_field_title"
          :title="$t('solfigr.sizes.bet_types')"
        />
        <div
          class="gw_btn ml-2"
          style="
            height: 1.5em;
            font-size: 0.75rem;
            --clr: var(--clr-grey-2);
            --clr-hover: var(--clr-white-0);
          "
          @click="$store.dispatch('router_set_dialogs', 'study-bettypes-help-dialog')"
        >
          {{ $t('common.how_it_works') }}
        </div>
      </div>
      <GwBtns
        :options="sizeModeOptions"
        :value="sizeMode"
        :class="forceOnlyFixed ? 'mr-auto not-allowed' : 'mr-auto'"
        :disabled="forceOnlyFixed ? ['dynamic', 'automatic'] : []"
        style="
          border-radius: 4px;
          background: var(--clr-black-1-3);
          --gwbtn-clr-back: var(--clr-black-1-3);
          --gwbtn-clr-active-white: var(--clr-black-3);
          --gwbtn-clr-back: var(--clr-black-1-3);
          --gwbtn-clr-active: var(--clr-ipoop-active);
          --gwbtn-size: 1rem;
          --gwbtn-height: 1.875rem;
          --gwbtns-padding: 2px;
          --gwbtn-clr-disabled: var(--clr-grey-2);
          --gwbtn-pointer-events-disabled: none;
        "
        tstPrefix="bet_size"
        @click="(_e, i) => handleSizesModesClick(i)"
      >
        <template #default="{ item }">
          {{ item.name }}
        </template>
      </GwBtns>
    </div>

    <div
      v-if="sizeMode === 'automatic'"
      class="d-flex clr-grey solfigrssz_expbox text-medium"
    >
      <div class="mdi mdi-information-outline mr-2"></div>
      {{ $t('solfigr.sizes.automatic_info') }}
    </div>

    <div
      v-if="sizeMode !== 'automatic'"
      class="solfigrssz_fields"
    >
      <div
        v-if="sizeMode !== 'fixed'"
        class="solfigrssz_fields_counts"
      >
        <div
          v-for="(value, key, mIndex) in fieldCounts"
          :key="key + mIndex"
          class="solfigrssz_fields_item"
          :class="key"
          :data-tst="key"
        >
          <div
            v-if="getField(key, 'numsOf')"
            :class="`solfigrssz_field solfigrssz_field--${key} flex-1`"
          >
            <GwTitleTooltip
              class="solfigrssz_field_title"
              :title="
                getTitle({
                  key,
                  fieldCounts,
                  index: mIndex,
                })
              "
              :tooltip="fieldsNames[`${key}_tooltip`]"
            />
            <div class="f-align-center position-relative mr-auto">
              <!-- style="gap: 0.25rem" -->
              <NumberInput
                style="z-index: 2; --input-color: var(--clr-ipoop-active)"
                class="solfigrssz_field_input mr-0"
                :min="getField(key, 'numsOf').min"
                :max="getFieldMax(key, 'numsOf')"
                :decimals="0"
                :hasWheelScroll="false"
                :step="1"
                :tabindex="inputTabIndex"
                :value="value"
                @input="val => handleNumsOfInput({ key, val, fieldKey: 'numsOf' })"
              />

              <div
                v-if="getField(key, 'numsOf').message(value)"
                class="text-small mr-auto weight_500 f-center no-events anim-fade-in"
                style="
                  color: var(--clr-ipoop-primary);
                  z-index: 1;
                  position: absolute;
                  left: 0;
                  right: 0;
                  bottom: -1rem;
                  font-weight: 700;
                "
              >
                {{ $t(`solfigr.sizes.${getField(key, 'numsOf').message(value)}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="visibleFields.allin"
        :class="`solfigrssz_field w-100 solfigrssz_field--add_allin`"
      >
        <Checkbox
          style="
            --icon-size: 1.5rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-ipoop-primary);
          "
          :value="playerFields.add_allin"
          data-tst="solfigr_add_allin"
          @click="toggleAllin(!playerFields.add_allin)"
        >
          <GwTitleTooltip
            :title="fieldsNames.add_allin"
            :tooltip="fieldsNames.add_allin_tooltip"
          />
        </Checkbox>
      </div>
      <div
        class="solfigrssz_fields_advanced"
        :class="[`solfigrssz_fields_advanced_${sizeMode}`, { 'bt-grey': sizeMode === 'dynamic' }]"
      >
        <div
          v-if="sizeMode === 'dynamic'"
          class="solfigrssz_fields_advanced_title"
        >
          <Checkbox
            class="mr-auto"
            data-tst="solfigr_stacks_sizes_checkbox"
            style="
              --icon-size: 1.25rem;
              --clr-disabled: var(--clr-grey-2);
              --clr-enabled: var(--clr-ipoop-primary);
              --clr-body-active: var(--clr-ipoop-primary2);
            "
            :asSwitch="true"
            :value="playerFields.use_fixed_sizes"
            @click="toggleShowAdvanced"
          >
            <GwTitleTooltip
              :title="$t('solfigr.sizes.use_fixed_sizes_options')"
              :tooltip="$t('solfigr.sizes.use_fixed_sizes_options_tooltip')"
            />
          </Checkbox>
        </div>

        <div
          v-if="playerFields.use_fixed_sizes || sizeMode === 'fixed'"
          class="solfigrssz_fields_advanced_content"
        >
          <div
            v-for="(key, index) in fieldTabs"
            :key="key"
            :data-tst="key"
          >
            <GwTitleTooltip
              class="solfigrssz_field_title"
              :title="
                getTitle({
                  key,
                  fieldCounts,
                  index,
                })
              "
              :tooltip="fieldsNames[`${key}_tooltip`]"
            />

            <div
              v-if="getField(key, 'sizes')"
              class="solfigrssz_fields_item"
              :class="key"
            >
              <!-- {{ playerFields[key] }} -- {{ key }} -->
              <div
                :class="`solfigrssz_field flex-1 solfigrssz_field--${key}`"
                style="flex-direction: row; gap: 0.25rem"
              >
                <div class="solfigrssz_field_inputs_items">
                  <div
                    v-for="(numStr, fieldIndex) in playerFields[key]"
                    :key="fieldIndex + key"
                    class="solfigrssz_field_inputs_items_item gw_input_wrapperss"
                  >
                    <NumberInputUnit
                      :ref="`numInput_${key}_${fieldIndex}`"
                      :inputProps="getUnitInputProps({ key, numStr })"
                      :inputValue="numStr.replace(/(%|x|e|b)/g, '')"
                      :unitValue="numStr.replace(/[0-9.]/g, '')"
                      :unitsOptions="
                        getField(key, 'sizes')[`units_${street === 'preflop' ? 'preflop' : 'flop'}`]
                      "
                      @input:all="
                        inputConf =>
                          handleSizesInput({
                            key,
                            inputConf,
                            index: fieldIndex,
                            fieldKey: 'sizes',
                          })
                      "
                      @input:keydown="
                        e =>
                          handleSizesKeydown({
                            e,
                            value: playerFields[key],
                            key,
                            fieldKey: 'sizes',
                          })
                      "
                      @click:unit="
                        i => {
                          handleSizesInput({
                            key,
                            inputConf: {
                              origVal: numStr.replace(/(%|x|e)/g, i),
                              numVal: Number(numStr.replace(/(%|x|e)/g, '')),
                            },
                            index: fieldIndex,
                            fieldKey: 'sizes',
                          })
                          focusSizeInput(fieldIndex, key)
                        }
                      "
                    />
                    <div
                      v-if="playerFields[key].length > getField(key, 'sizes').min_length"
                      class="solfigrssz_field_inputs_items_item_close icon_btn mdi pa-1 mdi-close-circle csst"
                      data-tst="remmove_size"
                      @click="removeSizeInput({ key, index: fieldIndex })"
                      @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
                    >
                      <div
                        class="csst_content clr-white"
                        style="position: fixed"
                        v-html="$t('common.remove_size')"
                      />
                    </div>
                  </div>
                  <div
                    v-if="getField(key, 'sizes').message(playerFields[key])"
                    class="f-align-center text-small no-events"
                    style="color: var(--clr-ipoop-primary); --height: 1.5rem; font-weight: 700"
                  >
                    {{ $t(`solfigr.sizes.${getField(key, 'sizes').message(playerFields[key])}`) }}
                  </div>
                  <div
                    v-if="playerFields[key].length < getField(key, 'sizes').max_length"
                    class="gw_btn flex-1 csst csst_nm text-medium"
                    style="
                      --clr-back: var(--clr-black-2);
                      --clr-hover-white: rgba(0, 172, 141, var(--brighten-hover));
                      --clr: var(--clr-ipoop-primary);
                      --clr-hover: var(--clr-ipoop-primary);
                      --height: 1.5rem;
                    "
                    data-tst="add_size"
                    @click="addSizeInput({ key, value: playerFields[key], fieldKey: 'sizes' })"
                    @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
                  >
                    <div class="mdi mdi-plus text-normal mr-1"></div>
                    {{ $t('common.add_size') }}
                    <div
                      class="csst_content clr-white"
                      style="position: fixed"
                      v-html="$t('common.add_size')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import {
  getSolfigrFields,
  getClonedBetSizes,
  getPreflopSizes,
} from '@/store/solfigr/solfigr_helpers'
import links_mix from '@/mixins/links_mix'

import NumberInputUnit from '@/components/lib/NumberInputUnit'
import GwBtns from '@/components/lib/GwBtns'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import NumberInput from '@/components/lib/NumberInput'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'

export default {
  name: 'SolfigrSizes',
  components: {
    NumberInputUnit,
    GwBtns,
    Checkbox,
    NumberInput,
    GwTitleTooltip,
  },
  mixins: [float_mix, format_mix, links_mix],
  props: {
    allow_limp: Boolean,
    cloneThisPlayerToRest: Boolean,
    playersCloningFirstPlayer: Object,
    inputTabIndex: Number,
    firstPlayer: Object,
    player: String,
    sizes: Object,
    sizesModes: Object,
    street: String,
    overlayCopyFlop: Boolean,
    overlayCopyFirstPlayer: Boolean,
    forceOnlyFixed: { type: Boolean, default: false },
  },
  emits: ['click:disableclonefirstplayer', 'click:disablecopyflop', 'update:sizes'],
  data() {
    return {
      conf: getSolfigrFields(),
      l_sizes: undefined,
    }
  },
  methods: {
    handleSizesModesClick(val) {
      if (this.forceOnlyFixed && val.id !== 'fixed') return

      if (this.l_sizes[this.street][this.player].mode === val.id) return

      this.l_sizes[this.street][this.player].mode = val.id
      this.emitUpdate()
    },
    toggleShowAdvanced() {
      this.l_sizes[this.street][this.player][this.sizeMode].use_fixed_sizes =
        !this.playerFields.use_fixed_sizes
      this.emitUpdate()
    },
    toggleAllin(bool) {
      this.l_sizes[this.street][this.player][this.sizeMode].add_allin = bool
      this.emitUpdate()
    },
    handleNumsOfInput({ key, val }) {
      if (this.l_sizes[this.street][this.player][this.sizeMode][key] === val) return
      this.l_sizes[this.street][this.player][this.sizeMode][key] = val
      this.emitUpdate()
    },
    handleSizesInput({ key, inputConf, index, fieldKey = 'sizes' }) {
      const conf = this.getField(key, fieldKey)
      const brdCheckParser = conf[`size_${this.street === 'preflop' ? 'preflop' : 'flop'}`].parser
      const oldVal = this.l_sizes[this.street][this.player][this.sizeMode][key][index]
      const parsed = brdCheckParser({ item: conf, inputConf, oldVal, street: this.street })
      const { numStr } = parsed
      if (this.l_sizes[this.street][this.player][this.sizeMode][key][index] === numStr) return
      this.l_sizes[this.street][this.player][this.sizeMode][key][index] = numStr
      this.emitUpdate()
    },
    removeSizeInput({ key, index }) {
      this.l_sizes[this.street][this.player][this.sizeMode][key].splice(index, 1)
      this.emitUpdate()
    },
    handleSizesKeydown({ e, value, key, fieldKey = 'sizes' }) {
      if (value.length >= this.getField(key, fieldKey).max_length) return
      if (e?.key === '+' || e?.key === 'Enter') {
        this.addSizeInput({ key, value, fieldKey })
      }
    },
    clearSizeInputs({ key, fieldKey = 'sizes' }) {
      this.l_sizes[this.street][this.player][this.sizeMode][key] = []
      this.emitUpdate()
    },
    addSizeInput({ key, value, fieldKey = 'sizes' }) {
      const conf = this.getField(key, fieldKey)
      const numStr =
        value?.[value?.length - 1] || conf[`${this.street}_default`]?.[0] || conf.default[0]
      this.l_sizes[this.street][this.player][this.sizeMode][key].push(numStr)
      this.emitUpdate()

      setTimeout(() => {
        const index = this.l_sizes[this.street][this.player][this.sizeMode][key].length - 1
        this.focusSizeInput(index, key)
      })
    },
    focusSizeInput(index, key) {
      const cc = this.$refs[`numInput_${key}_${index}`]
      if (cc) {
        if (cc[0]) {
          cc[0].focusInput(['selectText'])
        }
      }
    },
    setSizes() {
      this.l_sizes = JSON.parse(JSON.stringify(this.sizes))
    },
    emitUpdate(sizes = this.l_sizes) {
      let l_sizes = sizes
      if (this.cloneThisPlayerToRest && !this.isPreflop) {
        // Apply changes of this player to every player which has cloning enabled
        const players = Object.keys(this.playersCloningFirstPlayer)
        for (let i = 0; i < players.length; i++) {
          if (this.playersCloningFirstPlayer[players[i]]) {
            const { sizes: cl_sizes } = getClonedBetSizes({
              sizes: l_sizes,
              street_from: this.street,
              street_to: this.street,
              player_from: this.player,
              player_to: players[i],
            })
            l_sizes = cl_sizes
          }
        }
      }
      this.$emit('update:sizes', l_sizes)
    },
    getField(key, fieldKey) {
      const res = this.visibleFields[fieldKey].find(ii => ii.id === key)
      return res
    },
    getFieldMax(key, fieldKey) {
      const field = this.visibleFields[fieldKey].find(ii => ii.id === key)
      const res = field[`max_${this.street}`] ?? field.max
      return res
    },

    getUnitInputProps({ key, numStr }) {
      const field = this.getField(key, 'sizes')
      const byUnits = field[`size_${this.street === 'preflop' ? 'preflop' : 'flop'}`].by_unit
      const byUnit = byUnits.find(u => numStr.includes(u.unit))
      const res = {
        stopOnMin: true,
        hasWheelScroll: false,
        focusOnMounted: false,
        // focusOnMounted: this.inputTabIndex !== -1 && !this.overlayCopyFlop && !this.overlayCopyOOP,
        // min: field.size.min,
        min: byUnit.min,
        max: byUnit.max,
        step: byUnit.step,
        decimals: byUnit.decimals,
        tabindex: this.inputTabIndex,
      }
      return res
    },
    getTitle({ key, fieldCounts, index }) {
      return (
        this.fieldsNames[key] +
        (this.isPreflop && Object.keys(fieldCounts).length - 1 === index && index > 0 ? '+' : '')
      )
    },
  },
  computed: {
    fieldTabs() {
      const fieldsKeys = [
        'bet_sizes',
        'raise_sizes',
        'second_raise_sizes',
        'third_plus_raise_sizes',
        'donk_sizes',
      ]

      return fieldsKeys.filter(key => key in this.playerFields)
    },
    fieldCounts() {
      const keys = [
        'bet_count',
        'raise_count',
        'second_raise_count',
        'third_plus_raise_count',
        'donk_count',
      ]

      return keys.reduce((acc, key) => {
        if (key in this.playerFields) {
          return { ...acc, [key]: this.playerFields[key] }
        }
        return acc
      }, {})
    },
    isBB() {
      return this.player === 'player_oop'
    },
    isPreflop() {
      return this.street === 'preflop'
    },
    visibleFields() {
      if (this.sizeMode === 'fixed') {
        return {
          sizes: [
            // this.isPreflop ? this.conf.preflop_bet_sizes : this.conf.flop_bet_sizes,
            this.conf.bet_sizes,
            this.conf.raise_sizes,
            this.conf.second_raise_sizes,
            this.conf.third_plus_raise_sizes,
            this.conf.donk_sizes,
          ],
        }
      }
      return this.playerFields.use_fixed_sizes
        ? {
            allin: [this.conf.add_allin],
            use_fixed_sizes: 'justkey',
            numsOf: [
              this.conf.bet_count,
              this.conf.raise_count,
              this.conf.second_raise_count,
              this.conf.third_plus_raise_count,
              this.conf.donk_count,
            ],
            sizes: [
              // this.isPreflop ? this.conf.preflop_bet_sizes : this.conf.flop_bet_sizes,
              this.conf.bet_sizes,
              this.conf.raise_sizes,
              this.conf.second_raise_sizes,
              this.conf.third_plus_raise_sizes,
              this.conf.donk_sizes,
            ],
          }
        : {
            allin: [this.conf.add_allin],
            numsOf: [
              this.conf.bet_count,
              this.conf.raise_count,
              this.conf.second_raise_count,
              this.conf.third_plus_raise_count,
              this.conf.donk_count,
            ],
            // use_fixed_sizes: 'justkey',
            sizes: [],
          }
    },
    sizeMode() {
      return this.sizes[this.street][this.player].mode
    },
    playerFields() {
      if (!this.isPreflop) {
        const res = { ...this.sizes[this.street][this.player][this.sizeMode] }

        return res
      }

      const res = getPreflopSizes({
        sizes: this.sizes[this.street][this.player][this.sizeMode],
        player: this.player,
        allow_limp: this.allow_limp,
      })
      return res
    },
    sizeModeOptions() {
      return [
        { id: 'automatic', name: this.$t('solfigr.sizes.automatic') },
        { id: 'dynamic', name: this.$t('solfigr.sizes.dynamic') },
        { id: 'fixed', name: this.$t('solfigr.sizes.fixed') },
      ]
    },
    fieldsNames() {
      const raise_sizes_tooltip = this.isPreflop
        ? this.isBB
          ? this.$t('solfigr.sizes.fields.bb_preflop_raise_sizes_tooltip')
          : this.$t('solfigr.sizes.fields.sb_preflop_raise_sizes_tooltip')
        : this.$t('solfigr.sizes.fields.raise_sizes_tooltip', {
            learMoreText: !this.$i18n.g1
              ? `<a target='_blank' class='weight_700 link-underline' tabindex='-1' href='${
                  this.links_url_links.learn_more_solfigr_sizes_tooltip.url
                }'>${this.$t('common.learn_more')}</a>`
              : this.$t('solfigr.sizes.fields.sizes_betting'),
            geobetText: !this.$i18n.g1
              ? `<a target='_blank' class='weight_700 link-underline' tabindex='-1' href='${
                  this.links_url_links.geometric_betting.url
                }'>${this.$t('solfigr.sizes.fields.sizes_geobet')}</a>`
              : this.$t('solfigr.sizes.fields.sizes_geobet'),
          })

      const rest = {
        add_allin: this.$t('solfigr.sizes.fields.add_allin'),
        add_allin_tooltip: this.$t('solfigr.sizes.fields.add_allin_tooltip'),

        bet_count: this.$t('solfigr.sizes.fields.bet_count'),
        bet_count_tooltip: this.$t('solfigr.sizes.fields.bet_count_tooltip'),

        raise_count: this.$t('solfigr.sizes.fields.raise_count'),
        raise_count_tooltip: this.$t('solfigr.sizes.fields.raise_count_tooltip'),

        second_raise_count: this.$t('solfigr.sizes.fields.second_raise_count'),
        third_plus_raise_count: this.$t('solfigr.sizes.fields.third_plus_raise_count'),

        donk_count: this.$t('solfigr.sizes.fields.donk_count'),
        donk_count_tooltip: this.$t('solfigr.sizes.fields.donk_count_tooltip'),

        bet_sizes: this.isPreflop
          ? this.isBB
            ? this.$t('solfigr.sizes.fields.bb_preflop_bet_sizes')
            : this.$t('solfigr.sizes.fields.sb_preflop_bet_sizes')
          : this.$t('solfigr.sizes.fields.bet_sizes'),
        bet_sizes_tooltip: this.isPreflop
          ? this.isBB
            ? this.$t('solfigr.sizes.fields.bb_preflop_bet_sizes_tooltip')
            : this.$t('solfigr.sizes.fields.sb_preflop_bet_sizes_tooltip')
          : this.$t('solfigr.sizes.fields.bet_sizes_tooltip', {
              geobetText: !this.$i18n.g1
                ? `<a target='_blank' class='weight_700 link-underline' tabindex='-1' href='${
                    this.links_url_links.geometric_betting.url
                  }'>${this.$t('solfigr.sizes.fields.sizes_geobet')}</a>`
                : this.$t('solfigr.sizes.fields.sizes_geobet'),
            }),
        raise_sizes: this.isPreflop
          ? this.$t('solfigr.sizes.fields.preflop_raise_sizes')
          : this.$t('solfigr.sizes.fields.raise_sizes'),

        third_plus_raise_sizes: this.$t('solfigr.sizes.fields.third_plus_raise_sizes'),
        third_plus_raise_sizes_tooltip: this.isBB
          ? this.$t('solfigr.sizes.fields.bb_third_plus_raise_sizes_tooltip')
          : this.$t('solfigr.sizes.fields.sb_third_plus_raise_sizes_tooltip'),

        raise_sizes_tooltip,

        donk_sizes: this.$t('solfigr.sizes.fields.donk_sizes'),
        donk_sizes_tooltip: this.$t('solfigr.sizes.fields.donk_sizes_tooltip', {
          donkText: !this.$i18n.g1
            ? `<a target='_blank' class='weight_700 link-underline' tabindex='-1' href='${
                this.links_url_links.donk_betting_tooltip.url
              }'>${this.$t('solfigr.sizes.fields.sizes_betting')}</a>`
            : this.$t('solfigr.sizes.fields.sizes_betting'),
          geobetText: !this.$i18n.g1
            ? `<a target='_blank' class='weight_700 link-underline' tabindex='-1' href='${
                this.links_url_links.geometric_betting.url
              }'>${this.$t('solfigr.sizes.fields.sizes_geobet')}</a>`
            : this.$t('solfigr.sizes.fields.sizes_geobet'),
        }),
      }
      const byStreet = {
        preflop: {
          second_raise_sizes: this.$t('solfigr.sizes.fields.second_raise_sizes'),
          second_raise_sizes_tooltip: this.isBB
            ? this.$t('solfigr.sizes.fields.bb_second_raise_sizes_tooltip')
            : this.$t('solfigr.sizes.fields.sb_second_raise_sizes_tooltip'),
          ...rest,
        },
        flop: {
          second_raise_sizes: this.$t('solfigr.sizes.fields.second_raise_sizes_flop'),
          second_raise_sizes_tooltip: raise_sizes_tooltip,
          ...rest,
        },
      }
      return this.isPreflop ? byStreet.preflop : byStreet.flop
    },
  },
  watch: {
    sizes: {
      immediate: true,
      handler: 'setSizes',
    },
  },
}
</script>
<style lang="scss" scoped>
.solfigrssz_player_ip_oop {
  .solfigrssz_fields_counts {
    display: flex;
    flex-wrap: wrap;
  }
  .solfigrssz_field_inputs_items {
    display: flex;
    flex-wrap: wrap;
  }
}

.solfigrssz {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;

  --clr-ipoop-active: var(--clr-white-0);
  --clr-ipoop-primary: var(--clr-primary);
  --clr-ipoop-primary2: var(--clr-primary-2);
  --clr-ipoop-error: var(--clr-error);

  &_expbox {
    padding: 0 0.25rem 0 0.25rem;
    border-radius: 4px;
  }
  &_bettypes {
    display: flex;
    flex-direction: column;
  }
  &_advanced {
    display: flex;
    flex-direction: column;
    justify-content: center;
    &_item {
      background: var(--clr-black-1-3);
      border-radius: 4px;
      padding: 0.5rem;
      font-weight: 600;
      display: flex;
      gap: 0.5rem;
      &_input {
        background: var(--clr-black-1);
        border-radius: 4px;
        padding: 0.25rem;
      }
    }
  }

  &_fields {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    &_counts {
      display: flex;
      flex-wrap: wrap;
      gap: 1.25rem;
    }
    &_advanced {
      display: flex;
      flex-direction: column;
      // gap: 0.5rem;
      gap: 1rem;
      &_dynamic {
        padding: 1.25rem 0 0 0;
      }
      &_content {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
      }
    }
  }
  &_field {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    &_title {
      margin: 0 0 0.25rem 0;
    }
    &_input {
      margin: 0 auto 0 0;
    }
    &_inputs {
      z-index: 55;
      &_items {
        flex: 1;
        gap: 0.5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        &_item {
          display: flex;
          align-items: center;
          max-height: 1.5rem;
          &_unit {
            position: absolute;
            right: 0;
          }
          &_close {
            // margin-left: 0.125rem;
            font-size: 1rem;
            color: var(--clr-black-4);
            &:hover {
              color: var(--clr-error);
            }
          }
        }
      }
    }
  }
}

.not-allowed {
  cursor: not-allowed;
}
</style>
